import Vue from "vue";
// import Vuex from "vuex";
import store from '@/store'
import Helper from "@/libs/Helper";
// import inject from 'vue'
// Vue.use(Vuex)
import VueCompositionAPI, {inject} from '@vue/composition-api'
// import { inject } from 'vue'
import {HubConnectionBuilder, LogLevel, HttpTransportType} from "@aspnet/signalr";
// export default (inject) => {

// Define Hub
const activityHub = new HubConnectionBuilder()
    .withUrl(`${Helper.baseUrl}activity`, {
        transport:HttpTransportType.WebSockets,
        skipNegotiation:true,
        accessTokenFactory: function () {
            console.log("Getting token for activityHub");
        },
    })
    .configureLogging(LogLevel.Information)
    .build();

// Inject
inject("activityHub", activityHub)

// Watch Methods
activityHub.on("UpdateCount", (res) => {
    store.commit("SetOnlineUsers", res);
});

// Hub starts
activityHub.start().catch(function (err) {
    return console.error(err);
});

// Hub start Functions
// with reconnect capability (async/await, not IE11 compatible)
async function start() {
    try {
        await activityHub.start();
    } catch (err) {
        console.log(err);
        setTimeout(() => start(), 5000);
    }
}

// Hub Close Functions
activityHub.onclose(async () => {
    await start();
});
